import { render, staticRenderFns } from "./ResellersPayouts.vue?vue&type=template&id=0fc8c8e1&scoped=true&lang=pug&"
import script from "./ResellersPayouts.vue?vue&type=script&lang=js&"
export * from "./ResellersPayouts.vue?vue&type=script&lang=js&"
import style0 from "./ResellersPayouts.vue?vue&type=style&index=0&id=0fc8c8e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8c8e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VIcon,VLayout,VProgressCircular,VRow,VTab,VTabItem,VTabs,VTabsItems})
